import { axiosInstance } from '@/lib/axios';
import { SaveImportPayload } from './types';

export function saveImport (props: SaveImportPayload) {
  return axiosInstance.post<any>(`/api/${props.companyId}/fileProcessing/saveImport`, {
    importId: props.importId,
    options: JSON.stringify(props.importedFileLogs),
    previousTaskId: props.previousTaskId,
    taskId: props.taskId,
  });
}
